import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: `${API_URL}/api`, withCredentials: true });

/**
 * Resolve a media URL stored in the DB to an absolute URL the browser can fetch.
 * - Empty/null → "" (callers should render a placeholder).
 * - Absolute http(s) URL → returned as-is.
 * - Relative path starting with `/api/...` → prefixed with REACT_APP_BACKEND_URL.
 * - Anything else (e.g. data:, blob:) → returned as-is.
 */
export const resolveMedia = (url) => {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/api/")) return `${API_URL}${url}`;
  if (url.startsWith("/assets/")) return url;
  if (url.startsWith("/")) return `${API_URL}${url}`;
  return url;
};

export const formatError = (detail) => {
  if (detail == null) return "Algo salio mal. Intente de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};

// Auth
export const login = (data) => api.post("/auth/login", data);
export const getMe = () => api.get("/auth/me");
export const logout = () => api.post("/auth/logout");

// Upload
export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post("/upload", formData, { headers: { "Content-Type": "multipart/form-data" } });
};

// Solutions
export const getSolutions = () => api.get("/solutions");
export const getSolution = (id) => api.get(`/solutions/${id}`);
export const createSolution = (data) => api.post("/solutions", data);
export const updateSolution = (id, data) => api.put(`/solutions/${id}`, data);
export const deleteSolution = (id) => api.delete(`/solutions/${id}`);

// Systems
export const getSystems = () => api.get("/systems");
export const getSystem = (id) => api.get(`/systems/${id}`);
export const createSystem = (data) => api.post("/systems", data);
export const updateSystem = (id, data) => api.put(`/systems/${id}`, data);
export const deleteSystem = (id) => api.delete(`/systems/${id}`);

// Technical Sheets
export const getSheets = (params) => api.get("/technical-sheets", { params });
export const createSheet = (data) => api.post("/technical-sheets", data);
export const updateSheet = (id, data) => api.put(`/technical-sheets/${id}`, data);
export const deleteSheet = (id) => api.delete(`/technical-sheets/${id}`);

// Projects
export const getProjects = (params) => api.get("/projects", { params });
export const createProject = (data) => api.post("/projects", data);
export const updateProject = (id, data) => api.put(`/projects/${id}`, data);
export const deleteProject = (id) => api.delete(`/projects/${id}`);

// Distributors
export const getDistributors = (params) => api.get("/distributors", { params });
export const createDistributor = (data) => api.post("/distributors", data);
export const updateDistributor = (id, data) => api.put(`/distributors/${id}`, data);
export const deleteDistributor = (id) => api.delete(`/distributors/${id}`);

// Contacts & Leads
export const submitContact = (data) => api.post("/contacts", data);
export const getContacts = () => api.get("/contacts");
export const captureLead = (data) => api.post("/leads", data);
export const getLeads = () => api.get("/leads");
export const getStats = () => api.get("/stats");

// Settings
export const getSettings = () => api.get("/settings");
export const getSetting = (key) => api.get(`/settings/${key}`);
export const updateSetting = (key, value) => api.put(`/settings/${key}`, { key, value });

export default api;
